<!-- 收货明细 -->
<template>
  <div class="page-content">
    <c-header pageName="收货明细"></c-header>
    <div class="nav-tool flex">
      <section :class="selectNav===0?'activity':''" @click="onNavChange(0)">未收货</section>
      <section :class="selectNav===1?'activity':''" @click="onNavChange(1)">已收货</section>
    </div>

    <div class="tool-content flex-wrap">
      <div class="order-header flex">
        <section>入库单号 : {{ inboundApply.sn }}</section>
      </div>
      <div class="button-tool flex" v-show="selectNav===1">
        <label @click="handleReceiptConfirm" v-if="inboundApply.status === 2">收货确认</label>
        <label @click="handlePrintAll">批量打印</label>
      </div>
      <div class="search-tool flex" v-show="selectNav===0">
        <van-search
          v-model="barCode"
          placeholder="请输入国际条码"
          show-action
          :autofocus="true"
          @search="onSearch"
        >
          <div slot="action" @click="onSearch">扫描国际条码</div>
        </van-search>
      </div>
    </div>
    <div class="search-result flex" v-show="selectNav===0 && searchOrder.length > 0">
      <div class="search-order flex" v-for="item in searchOrder">
        <div class="order-left">
          <section>商品名称 : {{ item.productName }}</section>
          <section>国际条码 : {{ item.barCode }}</section>
          <section>规格 : {{ item.specVal }}</section>
          <section>数量 : {{ item.preQty }}/{{ item.qty || 0 }}</section>
        </div>
        <div class="order-right">
          <section @click="onShowEditDialog(item)">
            <span>维护</span>
            <i class="iconfont xiangyou1"></i>
          </section>
        </div>
      </div>
    </div>
    <!-- <div class="receiving-button flex" v-show="selectNav==0 && searchOrder.goodsInfoResponseVO">
        <label @click="onInstockDetailSubmit">收货确认</label>
    </div> -->
    <van-list
      v-show="selectNav===1"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="goods-item flex-wrap" v-for="(item,index) in orderList" :key="index">
        <section>商品名称 : {{ item.productName }}</section>
        <section>国际编码 : {{ item.barCode }}</section>
        <section>数量 : {{ item.qty }}</section>
        <section>板号 : {{ item.bandSn }}</section>
        <section>批次 : {{ item.batSn }}</section>
        <section>商品状态 :&nbsp;
<!--          <span :style="item.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">-->
<!--            {{ item.defectFlag ? "不良品" : "良品" }}-->
<!--          </span>-->
          <div v-for="status in ProductStatus()" :key="status.value">
            <span v-if="status.value === item.productStatus" :style="'color:' + status.color">
              {{ status.label }}
            </span>
          </div>
        </section>
        <section>库位 : {{ item.slCode }}</section>
        <section class="button-tool" v-if="selectNav===1">
          <label style="background-color:#9AC0CD;" @click="handlePrint(item)">打印</label>
          <label v-if="item.status === 0" style="background-color:#EEB422;" @click="onShowEditDialog(item)">修改</label>
          <label v-if="item.status === 0"  @click="onDelGoodsDetail(item.id)">删除</label>
          <label style="background-color:#BC8F8F;" @click="onShowDetailDialog(item)">详细信息</label>
        </section>
        <section class="button-tool" v-if="selectNav===0">
          <label @click="onShowEditDialog(item)">维护</label>
        </section>
      </div>
    </van-list>
    <c-editDialog :show="editDialogShow" @closeDialog="closeEditDialog" :info="editInfoDetail"
                  :saveDetailInfoType="saveDetailInfoType" @detailEventSuccess="detailEventSuccess"></c-editDialog>
    <c-goodsDetail :show="detailDialogShow" @closeDialog="closeDetailDialog" :info="editInfoDetail"></c-goodsDetail>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import EditDialog from "../components/receivingDetailEditDialog.vue";
import GoodsDetailDialog from "../components/receivingGoodsDetailDialog.vue";
import Utils from "../util/utils";
import DataFormat from "../util/dataFormat";
import {ProductStatus} from "../common/constant";

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      loading: false,
      finished: true,
      orderId: "",
      orderSn: "",
      barCode: "",
      selectNav: 0, // 0-未收货，1-已收货
      saveDetailInfoType: 0, // 明细保存方式（0--新增，1--更新）
      orderList: [],
      searchOrder: [],
      editDialogShow: false, // 显示编辑弹框
      detailDialogShow: false, // 显示详情弹窗
      editInfoDetail: {}, // 选择进行维护的数据
      inboundApply: {}, // 入库申请单信息
    };
  },
  components: {
    "c-header": Header,
    "c-editDialog": EditDialog,
    "c-goodsDetail": GoodsDetailDialog,
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.orderSn = this.$route.query.orderSn;
    this.getInboundApply();
  },
  methods: {
    ProductStatus() {
      return ProductStatus
    },
    // 导航切换
    onNavChange(value) {
      if (this.selectNav === value) {
        return;
      }
      this.selectNav = value;
      this.currentPage = 1;
      this.orderList = [];
      if (value === 1) {
        this.getInboundApply();
        this.getReceivingDetailPage();
      } else {
        this.searchOrder = [];
      }
    },
    // 入库申请单信息
    getInboundApply() {
      this.$post(this.URL.findApplyById, {id: this.orderId}).then(res => {
        if (res.success && res.data) {
          this.inboundApply = res.data;
        }
      });
    },
    // 国际条码码搜索
    onSearch() {
      if (!this.barCode) {
        this.$toast.fail("请输入国际条码");
        return;
      }
      this.currentPage = 1;
      this.orderList = [];
      this.getInboundDetailPage();
    },
    // 获取明细(已收货)
    getReceivingDetailPage() {
      let param = {
        inboundApplyId: this.orderId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      this.$post(this.URL.getReceivingDetailPage, param).then(res => {
        if (res.success) {
          this.orderList = [...this.orderList, ...res.data.records];
          this.finished = res.data.totalPage <= this.currentPage;
          this.loading = false;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 获取明细（搜索国际条码）
    getInboundDetailPage() {
      let param = {
        applyId: this.orderId,
        barCode: this.barCode,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      this.$post(this.URL.getInboundDetailPage, param).then(res => {
        if (res.success && res.data && res.data.records && res.data.records.length > 0) {
          this.searchOrder = res.data.records;
          this.barCode = "";
        } else {
          this.barCode = "";
          this.$toast.fail("入库单不存在该商品");
        }
      });
    },
    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        if (this.selectNav === 1) {
          this.getReceivingDetailPage();
        } else {
          this.getInboundDetailPage();
        }
      }
    },
    // 显示编辑弹框
    onShowEditDialog(data) {
      this.editDialogShow = true;
      const advanceDay = data.product && data.product.goods ? data.product.goods.advanceDay : 30;
      if (this.selectNav === 0) {
        this.editInfoDetail = {
          inboundApplyId: data.applyId,
          applyDetailId: data.applyDetailId,
          inboundDetailId: data.id,
          productId: data.productId,
          productCode: data.productCode,
          barCode: data.barCode,
          productName: data.productName,
          specVal: data.specVal,
          advanceDay: advanceDay,
          packSpecVal: data.product && data.product.goods ? data.product.goods.packingSpec : '',
          productDate: DataFormat.formatDate(new Date(), "YYYY-MM-DD"),
          invalidDate: DataFormat.dateChange(0, new Date(), advanceDay)
        };
        this.saveDetailInfoType = 0;
      } else {
        this.saveDetailInfoType = 1;
        this.editInfoDetail = {
          id: data.id,
          inboundApplyId: data.inboundApplyId,
          applyDetailId: data.applyDetailId,
          inboundDetailId: data.inboundDetailId,
          productId: data.productId,
          productCode: data.productCode,
          barCode: data.barCode,
          productName: data.productName,
          specVal: data.specVal,
          qty: data.qty,
          boxQty: data.boxQty,
          productDate: data.productDate,
          invalidDate: data.invalidDate,
          batSn: data.batSn,
          itemSn: data.itemSn,
          packSpecVal: data.product && data.product.goods ? data.product.goods.packingSpec : '',
          productStatus: data.productStatus,
          advanceDay: advanceDay,
        };
      }
    },
    // 显示详情弹框
    onShowDetailDialog(data) {
      this.detailDialogShow = true;
      this.editInfoDetail = data;
    },
    // 关闭编辑弹框
    closeEditDialog() {
      this.editDialogShow = false;
    },
    closeDetailDialog() {
      this.detailDialogShow = false;
    },

    // 收货确认
    handleReceiptConfirm() {
      let param = {
        id: this.orderId
      };
      let barCode = "";
      this.$post(this.URL.findException,  param).then(res => {
        if (res.data && res.data.length > 0) {
          barCode = res.data.map(item => item.barCode).join(",");
        }
        if (barCode) {
          this.$dialog.confirm({
            message: barCode + "商品收货数量异常是否确认收货?",
            cancelButtonText: "取消",
            confirmButtonText: "确定",
            cancelButtonColor: "#dc6350",
            confirmButtonColor: "#dc6350",
          }).then(() => {
            this.handleShelvesConfirm(param);
          }).catch(() => {});
        } else {
          this.handleShelvesConfirm(param);
        }
      })
    },
    //收货确认
    handleShelvesConfirm(param) {
      this.$post(this.URL.receiptConfirm, param).then(res => {
        if (res.success) {
          this.$toast.success("收货成功");
          this.$router.push("/receiving");
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 删除收货明细
    onDelGoodsDetail(id) {
      this.$post(this.URL.deleteBand, {id: id}).then(res => {
        if (res.success) {
          this.$toast.success("删除成功");
          this.currentPage = 1;
          this.orderList = [];
          this.getReceivingDetailPage();
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 明细保存成功，切换
    detailEventSuccess() {
      this.selectNav = 1;
      this.currentPage = 1;
      this.orderList = [];
      this.getReceivingDetailPage();
    },
    handlePrint(item) {
      let data = "1," + Utils.formatStr(item.productName, 16, '...') + "," + item.bandSn + ",国际条码:" + item.barCode + ",货主:" + Utils.formatStr(item.shipper.name, 8, '...') + ",失效日期:" + DataFormat.formatDate(item.invalidDate, "YYYY-MM-DD")
      window.printSupport.share(data)
    },
    handlePrintAll() {
      if (this.orderList && this.orderList.length > 0) {
        this.orderList.forEach(item => {
          this.handlePrint(item)
        })
      } else {
        this.$toast.fail("没有数据可打印")
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  width: 100%;
  justify-content: center;
  padding: 0 3rem;
  height: 3rem;
  align-items: center;
  background-color: #dc6350;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }
}

.tool-content {
  font-size: 0.8rem;
  color: #444;
  padding: 0.5rem 0.5rem 0 0.5rem;

  .order-header {
    height: 3rem;
    align-items: center;
    font-size: 0.9rem;
  }

  .button-tool {
    height: 2.5rem;
    align-items: center;
    padding-bottom: 0.5rem;
    border-bottom: 0.2rem solid #f0f0f0;

    label {
      display: inline-flex;
      margin-right: 0.5rem;
      height: 1.8rem;
      align-items: center;
      padding: 0 0.8rem;
      background-color: #dc6350;
      border-radius: 0.2rem;
      color: white;
    }
  }

  .search-tool {
    height: 2.5rem;
    align-items: center;
    border-radius: 0.3rem;
    border: 1px solid #f0f0f0;

    .van-search {
      width: 100%;
      padding: 0;
      //box-shadow: 1px 2px 1px #f0f0f0;
      .van-search__action {
        background-color: white;
      }
    }
  }
}

.search-result {
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  color: #444;
  margin-top: 0.5rem;
  background-color: #fafafa;
  border-radius: 0.3rem;
  margin: 0.5rem;

  .order-left {
    display: inline-flex;
    width: 80%;
    flex-wrap: wrap;

    section {
      display: flex;
      width: 100%;
      padding: 0.2rem 0;
    }
  }

  .order-right {
    display: inline-flex;
    width: 20%;
    align-items: center;
    justify-content: center;

    section {
      display: inline-flex;
      background-color: #dc6350;
      color: white;
      padding: 0.3rem 0.5rem;
      border-radius: 0.2rem;
    }
  }
}

.receiving-button {
  justify-content: center;
  padding-top: 1rem;
  font-size: 0.85rem;

  label {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16rem;
    height: 2.2rem;
    background-color: #dc6350;
    color: white;
    border-radius: 0.2rem;
  }
}

.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;

  .goods-item {
    border-bottom: 1px solid #f0f0f0;
    padding: 0.5rem 0;

    section {
      display: flex;
      width: 100%;
      line-height: 1.2rem;
    }

    .button-tool {
      height: 2.5rem;
      align-items: center;

      label {
        display: inline-flex;
        margin-right: 0.5rem;
        height: 1.8rem;
        align-items: center;
        padding: 0 0.8rem;
        background-color: #dc6350;
        border-radius: 0.2rem;
        color: white;
      }
    }
  }

  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }

}

.van-field__control {
  background-color: white;
}

.van-search .van-cell {
  background-color: white;
}

.van-search__content {
  background-color: white;
}

.van-search__action {
  border-left: 1px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReceivingDetail.vue